const mediaQuery = window.matchMedia("(max-width: 1024px)");
const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#9ea9cf",
    width: mediaQuery.matches ? "100%" : "25%",
    height: "65%",
    padding: "0px",
    margin: "0px",
  },
};

export default modalStyles;
